import React from 'react';
import moment from 'moment'
import { get } from 'lodash';
import { DayPicker } from 'react-day-picker';
import 'react-day-picker/dist/style.css';
import ja from 'date-fns/locale/ja';
import Icon from '@mdi/react';

import { BasicForm } from './BasicForm.jsx';
import { FormLabel } from '../FormLabel.jsx';
import { FormErrorMessage } from '../FormErrorMessage.jsx';
import { isDateDisabled } from '../../../../../../utils/date.js';
import { getScrollTopToTarget } from '../../../../../../utils/scrollUtil.js';
import { mdiCalendar } from '../../../../../../images/svg';

export class DateForm extends BasicForm {
  containerRef = React.createRef(null);
  datePickerWrapperRef = React.createRef(null);

  state = {
    showDatePicker: false,
  }

  onFocus = () => {
    setTimeout(() => {
      const chatBody = document.querySelector('.cu-ui-chat-body');
      chatBody.scrollTop = getScrollTopToTarget(this.containerRef.current, chatBody);
    }, 500);
  }

  /**
   * [date] argument will be of Date instance
   *   Need to format with moment
   * [date] argument will be [null] when clear button is clicked
   *   Need to set empty string
   * @param {Date} date
   */
  onChange = (date) => {
    if (date) {
      if (this.isDayBlocked(date)) {
        this.props.input.onChange("");
      } else {
        const formatted = moment(date).format("YYYY-MM-DD");
        this.props.input.onChange(formatted);
      }

    } else {
      this.props.input.onChange("");
    }
    this.setState({ showDatePicker: false })
  }

  isDayBlocked = (day) => {
    return isDateDisabled({
      day,
      validations: this.props.object.validations
    });
  }

  onShowDatePicker = (value) => {
    this.setState({ showDatePicker: value })
  }

  onClickBackdrop = (e) => {
    if (this.datePickerWrapperRef.current.contains(e.target)) {
      return
    }
    this.onShowDatePicker(false)
  }

  onClearDatePicker = (e) => {
    this.onChange("")
  }

  onChangeInputDate = (e) => {
    this.props.input.onChange(e.target.value);
  }

  parseDateString = (string) => {
    const date = moment(string, 'YYYY-MM-DD')
    return date.isValid() ? new Date(date) : null
  }

  onCommitInputDate = (e) => {
    if (this.parseDateString(e.target.value)) {
      this.onChange(this.parseDateString(e.target.value))
    } else {
      this.onChange("")
    }
  }

  render() {
    const { input, disabled, meta, object } = this.props;

    const date = this.parseDateString(input.value)

    const startDate = new Date(get(this.props, 'object.validations.start_date'));
    const endDate = new Date(get(this.props, 'object.validations.end_date'));

    return (
      <div className="cu-ui-form-group cu-ui-date-form" ref={this.containerRef}>
        <FormLabel
          utilText={this.props.utilText}
          valid={meta.valid}
          label={object.label}
          required={object.validations.required}
        />
        <div className="cu-ui-date-form__box">
          <input
            value={input.value}
            onChange={this.onChangeInputDate}
            onBlur={this.onCommitInputDate}
            disabled={disabled}
            placeholder="YYYY-MM-DD"
          />
          <Icon
            className="cu-ui-date-form__date_icon"
            size="24"
            onClick={() => this.onShowDatePicker(true)}
            path={mdiCalendar}
          />
        </div>
        {this.state.showDatePicker && (
          <div className="cu-ui-date-form__popup" onClick={this.onClickBackdrop}>
            <div className="cu-ui-date-form__date-picker-wrapper" ref={this.datePickerWrapperRef}>
              <div className="cu-ui-date-form__date-picker-clear-btn-wraper">
                <button className="cu-ui-date-form__date-picker-clear-btn" onClick={this.onClearDatePicker}>Clear</button>
              </div>
              <DayPicker
                mode="single"
                locale={ja}
                className="cu-ui-date-form__date-picker"
                selected={date}
                defaultMonth={date}
                onSelect={this.onChange}
                modifiers={{ blocked: this.isDayBlocked }}
                modifiersStyles={{ blocked: blockedDayStyle }}
                fromYear={1900}
                toYear={2100}
                captionLayout="dropdown"
              />
            </div>
          </div>
        )}
        <FormErrorMessage
          error={meta.error}
          touched={meta.touched}
        />
      </div>
    );
  }
}

const blockedDayStyle = { opacity: 0.5, cursor: 'not-allowed' };
